import React from "react";
import { Navigate } from "react-router-dom";
import { observer } from "mobx-react"; 
import { withRouter } from "@mindmemobile/mm-shared-global";
import { PurchaseStore } from "../../shared/store";
import { UpsertPurchaseActiveStep } from "../../shared/enums";

interface IProps {
  purchaseStore: PurchaseStore;
  children: React.ReactElement;
  currentRoute: UpsertPurchaseActiveStep;
  checkOutId: string;
  isPurchaseLink: boolean;
}

const PurchaseProtectedRoute: React.FC<IProps> = ({
  children,
  currentRoute,
  purchaseStore,
  checkOutId,
  isPurchaseLink,
}) => {
  let isValid = false;

  switch (purchaseStore?.activeStep) {
      case UpsertPurchaseActiveStep.Purchase:
          isValid = currentRoute === UpsertPurchaseActiveStep.Purchase;
          break;
      case UpsertPurchaseActiveStep.AddOn:
          isValid = currentRoute === UpsertPurchaseActiveStep.AddOn;
          break;
      case UpsertPurchaseActiveStep.Options:
          isValid = currentRoute === UpsertPurchaseActiveStep.Options;
          break;
      case UpsertPurchaseActiveStep.Payment:
          isValid = currentRoute === UpsertPurchaseActiveStep.Payment;
          break;
      case UpsertPurchaseActiveStep.Success:
          isValid = currentRoute === UpsertPurchaseActiveStep.Success;
          break;
  }

  return isValid ? (
      children
  ) : (
      <Navigate to={`/app/purchase/${isPurchaseLink ? 'purchase-link' : 'checkout'}/${checkOutId}`} />
  );
};

export default withRouter(observer(PurchaseProtectedRoute));
